import PropTypes from 'prop-types';
import { Box, Typography, CircularProgress } from '@mui/material';

/**
 * Shown while a connect attempt is in flight so the sensor manager doesn't
 * look stalled during the (multi-second, multi-attempt) HELLO handshake.
 * When attempt info is available it surfaces "attempt N of M".
 */
export default function ConnectingIndicator({ attempt, maxAttempts }) {
  const hasAttempt = Number.isFinite(attempt) && Number.isFinite(maxAttempts);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 400,
        textAlign: 'center',
      }}
    >
      <CircularProgress sx={{ mb: 3 }} />
      <Typography variant="h5" gutterBottom>
        {hasAttempt ? 'Trying to reach your sensor…' : 'Connecting to your sensor…'}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
        {hasAttempt
          ? `Attempt ${attempt} of ${maxAttempts}. This can take a few seconds — keep the sensor plugged in.`
          : 'This can take a few seconds — keep the sensor plugged in.'}
      </Typography>
    </Box>
  );
}

ConnectingIndicator.propTypes = {
  attempt: PropTypes.number,
  maxAttempts: PropTypes.number,
};
